import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getCurrentUser } from "../auth";

export default function ProtectedRoute({ children }) {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const user = getCurrentUser();
    if (!user) {
      navigate("/login", { replace: true });
      return undefined;
    }

    user.getSession((err, session) => {
      if (err || !session?.isValid()) {
        navigate("/login", { replace: true });
        return;
      }
      setChecking(false);
    });

    return undefined;
  }, [navigate]);

  if (checking) {
    return <div className="ops-loading">Verificando sesión…</div>;
  }

  return children;
}
